export default __webpack_public_path__ + "static/media/13844.international-financial-program-board.photo.44a42031.jpg";